export const legalPages = {
  privacy: {
    title: "Privacy Policy",
    updated: "June 2026",
    sections: [
      {
        h: "Who we are",
        p: [
          "Stove Scotland (\"we\", \"us\") supplies, installs and maintains multi fuel and wood burning stoves across Scotland. This policy explains what personal information we collect through this website, how we use it and the rights you have under UK data protection law (UK GDPR and the Data Protection Act 2018).",
          "Contact us about anything in this policy at info@stovescotland.co.uk or on 01501 760051.",
        ],
      },
      {
        h: "What we collect",
        intro: "When you use our Free Quote / Contact form we collect the details you give us:",
        list: [
          "Your name, contact number and email address",
          "Your address, town and postcode (so we can plan a survey and installation)",
          "Your message and how you heard about us",
          "An optional photo of where you would like your stove located",
        ],
      },
      {
        h: "How we use it",
        list: [
          "To respond to your enquiry and prepare a free, no obligation quote",
          "To arrange a site survey, spill test or installation if you go ahead",
          "To send you a confirmation email that we have received your request",
          "To keep a record of enquiries in our secure enquiry inbox",
        ],
        p: ["Our lawful basis is your consent when you submit the form and, if you proceed, taking steps to enter into a contract with you. We do not sell your information or use it for marketing lists."],
      },
      {
        h: "Who we share it with",
        p: [
          "Your enquiry is delivered to us by email using Resend (our email delivery provider) and stored in our website's secure database and file storage. These providers process data only on our instructions. We do not otherwise share your information unless required by law.",
        ],
      },
      {
        h: "How long we keep it",
        p: ["Enquiries are kept for up to 24 months so we can follow up on quotes and honour any guarantee. If you become a customer, installation records are kept for as long as needed for warranty and safety purposes. You can ask us to delete your enquiry at any time."],
      },
      {
        h: "Your rights",
        list: [
          "Access a copy of the information we hold about you",
          "Ask us to correct or delete it",
          "Object to or restrict how we use it",
          "Withdraw consent at any time",
          "Complain to the Information Commissioner's Office (ico.org.uk) if you are unhappy with how we handle your data",
        ],
        p: ["To exercise any of these rights, email info@stovescotland.co.uk."],
      },
      {
        h: "Security",
        p: ["Information sent through this website is encrypted in transit (HTTPS). Access to our enquiry inbox is password protected and limited to the Stove Scotland team."],
      },
    ],
  },
  terms: {
    title: "Terms & Conditions",
    updated: "June 2026",
    sections: [
      {
        h: "Using this website",
        p: ["By using stovescotland.co.uk you agree to these terms. The content is provided for general information about our services. We do our best to keep it accurate and up to date but it does not form part of any contract."],
      },
      {
        h: "Quotes",
        p: [
          "Quotes provided through this website or by email are free and without obligation. Every quote is an estimate based on the information and photos you supply and is subject to a site survey. The final price may change if the survey reveals additional work (for example flue lining, hearth or chimney repairs, or building regulation requirements).",
          "Advertised package prices (such as our Skye supply and install package) are starting prices for a standard installation and may vary depending on your property.",
        ],
      },
      {
        h: "Installations and payment",
        list: [
          "A deposit may be required to secure your stove and installation date; the balance is due on completion.",
          "We accept all major credit and debit cards, bank transfer and cash.",
          "Installation dates are agreed in advance. We will let you know as soon as possible if a date needs to change.",
          "Goods remain the property of Stove Scotland until paid for in full.",
        ],
      },
      {
        h: "Our guarantee",
        p: ["Where we state that we can resolve a stove problem (such as down draft, difficulty lighting or a smoke filled room) or your money back, this applies to remedial work we carry out and is subject to a survey and our written agreement of the work required. Manufacturer warranties apply to stoves and parts we supply."],
      },
      {
        h: "Liability",
        p: ["Nothing in these terms limits our liability for death or personal injury caused by our negligence, or for anything else that cannot be limited by law. Otherwise we are not liable for indirect losses or for problems caused by misuse of a stove, use of unsuitable fuel, or work carried out by others."],
      },
      {
        h: "Governing law",
        p: ["These terms are governed by the law of Scotland and any dispute will be dealt with by the Scottish courts. Your statutory rights as a consumer are not affected."],
      },
    ],
  },
  cookies: {
    title: "Cookie Policy",
    updated: "June 2026",
    sections: [
      {
        h: "What cookies are",
        p: ["Cookies and similar technologies (such as local storage) are small pieces of information saved on your device by a website. They help a site work properly and remember your choices."],
      },
      {
        h: "What this website uses",
        list: [
          "Strictly necessary storage - our secure enquiry inbox uses local storage to keep the Stove Scotland team signed in. This is only set for team members who log in and is never used to track visitors.",
          "Embedded video - if you choose to play our promotional video, it is streamed from YouTube, which may set its own cookies. See Google's privacy policy for details. No YouTube cookies are set unless you press play.",
        ],
        p: ["We do not use advertising cookies, analytics cookies or any third-party tracking on this website."],
      },
      {
        h: "Managing cookies",
        p: ["You can clear or block cookies and site data in your browser settings at any time. Blocking cookies will not affect your ability to browse this site or send us a quote request."],
      },
      {
        h: "Contact",
        p: ["Questions about this policy? Email info@stovescotland.co.uk."],
      },
    ],
  },
};
